import TextElementRenderer from "@/components/form_builder/elements/text/TextElementRenderer";
import SelectElementRenderer from "@/components/form_builder/elements/select/SelectElementRenderer";
import TextareaElementRenderer from "@/components/form_builder/elements/textarea/TextareaElementRenderer";
import CheckboxElementRenderer from "@/components/form_builder/elements/checkbox/CheckboxElementRenderer";
import RadioElementRenderer from "@/components/form_builder/elements/radio/RadioElementRenderer";
import NumberElementRenderer from "@/components/form_builder/elements/number/NumberElementRenderer";
import DatetimeElementRenderer from "@/components/form_builder/elements/datetime/DatetimeElementRenderer.vue";

export default {
  TextElementRenderer, SelectElementRenderer, TextareaElementRenderer, CheckboxElementRenderer,
  RadioElementRenderer, NumberElementRenderer, DatetimeElementRenderer
}
